import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, FlexCenterBetweenWrapper, Mb2,
  CursorPointerWrapper, CustomBorderWrapper, P3, Mt2,
  BorderBottomWrapper, Mr2, PrimaryBackground50Wrapper,
  FullWidthFlexBoxWrapper, FullWIdthColumnScrollWrapper,
  GenericWrapper, Px3, Mt4, CustomBackgroundWrapper, Mb4,
  MaxWidthHeight, FlexCenterJustifyCenterWrapper, Py2,
  FullWidthFlexboxCentered, FlexBoxWrapper
} from 'wrappers';
import { Icon, CustomBorderlessInput, SecondaryTextXs, ClickableIcon, TagText } from 'atoms';
import Controller from './controller';
import { escapedRegex } from 'utils';
import internalState from './internalState';
import { DownCaretSvg, CheckboxSvg } from 'components/icons';
import { SearchTermButtonTag, TextButton, SearchTermButton } from 'molecules';

export const definition = {
  name: 'TagsDropdown',
  controller: Controller,
  initialProps: ({ selectedIds, entries, label, icon, noTagIds, makeReadyCategory }) => ({ selectedIds, entries, label, icon, noTagIds, makeReadyCategory }),
  props: internalState,
  elements: [
    {
      wrapper: CustomBorderWrapper,
      name: 'Wrapper',
      isButton: true,
      bindings: ({ isOpen, containerRef, inputRef }) => ({ isOpen, containerRef, inputRef }),
      displayState: ({ isOpen }) => ({
        hoverColor: `${window.settings?.primary_color ?? '#1DBD6B'}`,
        borderRadius: '8px',
        border: isOpen ? `1px solid ${window.settings?.primary_color ?? '#1DBD6B'}` : '1px solid #E3E3E3',
        background: '#FFFFFF'
      }),
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          wrapper: CustomBackgroundWrapper,
          name: 'HeaderWrapper',
          displayState: ({ isOpen, selectedIds, entries }) => ({
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px', background: selectedIds.filter(id => entries.map(e => e.id).includes(id)).length > 0 && !isOpen ? `${window?.settings?.primary_color ?? '#1DBD6B'}0D` : ''
          }),
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'LeftSide',
              renderIf: ({ isOpen }) => !isOpen,
              elements: [
                {
                  component: wrap(Icon, Mr2),
                  name: 'Icon',
                  renderIf: ({ icon }) => !!icon,
                  displayValue: ({ icon }) => icon
                },
                {
                  component: SecondaryTextXs,
                  name: 'Label',
                  renderIf: ({ label }) => !!label,
                  displayValue: ({ label }) => label
                }
              ]
            },
            {
              wrapper: GenericWrapper,
              name: 'Search',
              ref: ({ inputRef }) => inputRef,
              elements: [
                {
                  component: CustomBorderlessInput,
                  name: 'Input',
                  renderIf: ({ isOpen }) => isOpen,
                  bindings: ({ searchVal }) => ({ value: searchVal, placeholder: 'Search...' })
                },
              ]
            },
            {
              component: ClickableIcon,
              name: 'Icon',
              renderIf: ({ isOpen }) => isOpen,
              bindings: ({ }) => ({}),
              displayValue: ({ }) => DownCaretSvg({ up: true })
            },
            {
              component: Icon,
              name: 'Icon',
              renderIf: ({ isOpen }) => !isOpen,
              displayValue: ({ }) => DownCaretSvg({})
            }
          ]
        },
        {
          component: BorderBottomWrapper,
          name: 'BorderBottom',
          renderIf: ({ isOpen, selectedIds, entries }) => isOpen && selectedIds.filter(id => entries.map(e => e.id).includes(id)).length === 0,
        },
        {
          wrapper: wrap(P3, PrimaryBackground50Wrapper),
          renderIf: ({ selectedIds, entries, makeReadyCategory, noTagIds }) => selectedIds.filter(id => entries.map(e => e.id).includes(id)).length > 0 || noTagIds.includes(makeReadyCategory.id),
          name: 'ButtonsWrapper',
          elements: [
            {
              wrapper: MaxWidthHeight,
              name: 'ButtonsWrapper',
              displayState: ({ }) => ({ height: '65px', display: 'flex' }),
              elements: [
                {
                  wrapper: wrap(wrap(FullWidthFlexboxCentered, FullWIdthColumnScrollWrapper), FlexCenterWrapper),
                  name: 'ButtonsWrapper',
                  displayState: ({ }) => ({ notPadded: true }),
                  elements: [
                    {
                      component: wrap(wrap(SearchTermButtonTag, Mr2), Mt2),
                      name: 'Button',
                      isListOf: { selectedId: ({ selectedIds, entries }) => selectedIds.filter(id => entries.map(e => e.id).includes(id)).slice(0, 40) },
                      bindings: ({ selectedId, entries, selectedIds, makeReadyCategory, noTagIds }) => ({ selectedIds, selectedId, label: entries.find(e => e.id === selectedId)?.label ?? '', color: entries.find(e => e.id === selectedId)?.color ?? '', noTagIds, makeReadyCategory })
                    },
                    {
                      component: wrap(wrap(SearchTermButton, Mr2), Mt2),
                      name: 'NoTag',
                      renderIf: ({ noTagIds, makeReadyCategory }) => noTagIds?.includes(makeReadyCategory.id),
                      bindings: ({ noTagIds, makeReadyCategory, selectedIds, entries }) => ({ text: 'NO TAGS', noTagIds, makeReadyCategory, selectedIds, entries })
                    },
                    {
                      component: SecondaryTextXs,
                      name: 'SeeMoreText',
                      renderIf: ({ selectedIds, entries }) => selectedIds.filter(id => entries.map(e => e.id).includes(id))?.length > 40,
                      displayValue: ({ }) => 'Open to see all'
                    }
                  ]
                },
              ]
            },
          ]
        },
        {
          wrapper: wrap(wrap(wrap(FlexCenterBetweenWrapper, Px3), Mt4), Mb2),
          name: 'ClearAllHeader',
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              component: SecondaryTextXs,
              name: 'SelectedText',
              displayValue: ({ selectedIds, entries }) => `${(selectedIds.filter(id => entries.map(e => e.id).includes(id)).length ?? 0)} Selected`
            },
            {
              component: TextButton,
              name: 'ClearAll',
              bindings: ({ selectedIds, entries }) => ({ mobileSmall: true, small: true, selectedIds, entries, title: (selectedIds.filter(id => entries.map(e => e.id).includes(id)).length ?? 0) > 0 ? 'Clear all' : 'Select all' }),
            }
          ]
        },
        {
          wrapper: MaxWidthHeight,
          name: 'BodyWrapper',
          displayState: ({ }) => ({ height: '235px', display: 'flex' }),
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: wrap(FullWIdthColumnScrollWrapper, FullWidthFlexBoxWrapper),
              name: 'Body',
              elements: [
                {
                  wrapper: wrap(wrap(wrap(FlexCenterWrapper, CursorPointerWrapper), Mb4), Px3),
                  name: 'NoTag',
                  isButton: true,
                  bindings: ({ noTagIds, makeReadyCategory, selectedIds, entries }) => ({ makeReadyCategory, noTagIds, selectedIds, entries }),
                  elements: [
                    {
                      component: wrap(Icon, Mr2),
                      name: 'Checkbox',
                      displayValue: ({ noTagIds, makeReadyCategory }) => CheckboxSvg({ checked: noTagIds.includes(makeReadyCategory.id) })
                    },
                    {
                      component: wrap(SecondaryTextXs, FlexBoxWrapper),
                      name: 'TagText',
                      displayValue: ({ }) => 'NO TAG'
                    },
                  ]
                },
                {
                  wrapper: wrap(wrap(wrap(FlexCenterWrapper, CursorPointerWrapper), Mb4), Px3),
                  name: 'Row',
                  isButton: true,
                  bindings: ({ entry, selectedIds, noTagIds, makeReadyCategory }) => ({ entry, selectedIds, noTagIds, makeReadyCategory }),
                  isListOf: {
                    entry: ({ entries, pageNumber, searchVal }) => entries.filter(e => escapedRegex(searchVal).test(e.label)).slice(0, pageNumber * 20)
                  },
                  elements: [
                    {
                      component: wrap(Icon, Mr2),
                      name: 'Checkbox',
                      displayValue: ({ entry, selectedIds }) => CheckboxSvg({ checked: selectedIds.includes(entry.id) })
                    },
                    {
                      component: wrap(TagText, FlexBoxWrapper),
                      name: 'TagText',
                      displayState: ({ entry }) => ({ color: entry.color }),
                      displayValue: ({ entry }) => entry.label ?? ''
                    },
                  ]
                },
                {
                  component: wrap(wrap(wrap(TextButton, FlexCenterJustifyCenterWrapper), Py2), PrimaryBackground50Wrapper),
                  name: 'LoadMore',
                  renderIf: ({ entries, pageNumber, searchVal }) => entries.filter(e => escapedRegex(searchVal).test(e.label)).length > 20 * pageNumber,
                  bindings: ({ pageNumber }) => ({ mobileSmall: true, small: true, title: 'Load more...', pageNumber })
                }
              ]
            }
          ]
        },
      ]
    }
  ]
};

export default ContainerComponent(definition);
